module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1004.f332f1d7.png";